/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type Heart_heartPortfolioItems = ReadonlyArray<{
    readonly portfolioId: string | null;
    readonly portfolioItemId: string | null;
    readonly " $refType": "Heart_heartPortfolioItems";
}>;
export type Heart_heartPortfolioItems$data = Heart_heartPortfolioItems;
export type Heart_heartPortfolioItems$key = ReadonlyArray<{
    readonly " $data"?: Heart_heartPortfolioItems$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Heart_heartPortfolioItems">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Heart_heartPortfolioItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portfolioId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portfolioItemId",
      "storageKey": null
    }
  ],
  "type": "PortfolioItemV2",
  "abstractKey": null
};
(node as any).hash = '90ec07cccf758fe32c2edbfb66e9ab69';
export default node;
